type LinkInternalProps = {
  externalHref?: never
  onClick?: never
  internalRoute: string
}
type LinkExternalProps = {
  externalHref: string // Will always open in new tab
  onClick?: never
  internalRoute?: never
}
type LinkButtonProps = {
  externalHref?: never
  onClick: (e: React.MouseEvent | React.KeyboardEvent) => void | Promise<void>
  internalRoute?: never
}
export type LinkActionProps = LinkInternalProps | LinkExternalProps | LinkButtonProps

export const isInternalLink = (props: LinkActionProps): props is LinkInternalProps => {
  return typeof props.internalRoute === 'string'
}

export const getLinkProps = (
  openInNewTab: boolean
): Pick<React.HTMLProps<HTMLAnchorElement>, 'target' | 'rel'> => {
  return {
    target: openInNewTab ? '_blank' : undefined,
    rel: openInNewTab ? 'noreferrer' : undefined,
  }
}
